import { Avatar, Box, Collapse } from "@mui/material";
import Flex from "@/components/Flex";
import Text from "@/components/Text";
import StyledButtonV2 from "@/components/app/StyledButtonV2";
import {
  CHART_COLORS,
  CHART_TYPOGRAPHY,
} from "@/components/app/provider/patient/chart";
import { getInitials } from "@/utils/utils";
import { APPOINTMENT_DRAWER_LABEL } from "../group-appointment-constant";
import { GroupSessionPatient } from "../group-appointment-types";
import PatientFormsPanel from "./PatientFormsPanel";

export type GroupSessionPatientRowProps = {
  patient: GroupSessionPatient;
  isFormsOpen: boolean;
  onToggleForms: (appointmentId: string) => void;
};

const ROW_AVATAR_SIZE = 26;

const GroupSessionPatientRow = ({
  patient,
  isFormsOpen,
  onToggleForms,
}: GroupSessionPatientRowProps) => (
  <Box sx={{ borderBottom: `1px solid ${CHART_COLORS.borderLight}` }}>
    <Flex
      alignItems="center"
      justifyContent="space-between"
      gap={1}
      sx={{ px: 2, py: 1.25 }}
    >
      <Flex alignItems="center" gap={1}>
        <Avatar
          sx={{
            width: ROW_AVATAR_SIZE,
            height: ROW_AVATAR_SIZE,
            fontSize: "10px",
            bgcolor: CHART_COLORS.surfaceAlt,
            color: CHART_COLORS.textDark,
          }}
        >
          {getInitials(patient.patientName)}
        </Avatar>

        <Flex flexDirection="column">
          <Text
            {...CHART_TYPOGRAPHY.body4}
            fontWeight={CHART_TYPOGRAPHY.weight.medium}
            c={CHART_COLORS.textDarker}
          >
            {patient.patientName}
          </Text>
          {!!patient.mrn && (
            <Text {...CHART_TYPOGRAPHY.body5} c={CHART_COLORS.textMutedGrey}>
              {patient.mrn}
            </Text>
          )}
        </Flex>
      </Flex>

      {!!patient.customForms && (
        <StyledButtonV2
          label={
            isFormsOpen
              ? APPOINTMENT_DRAWER_LABEL.hideForms
              : APPOINTMENT_DRAWER_LABEL.viewForms
          }
          variant="text"
          aria-expanded={isFormsOpen}
          onClick={() => onToggleForms(patient.appointmentId)}
        />
      )}
    </Flex>

    <Collapse in={isFormsOpen} unmountOnExit>
      <PatientFormsPanel
        appointmentId={patient.appointmentId}
        customForms={patient.customForms}
      />
    </Collapse>
  </Box>
);

export default GroupSessionPatientRow;
